import { State } from '../../reducers/rootReducer'
import { CarlineFilterGroup } from '../../../entities/CarlineFiltersData'

const carlineFilterGroupsSelector = (state: State): CarlineFilterGroup[] => state.carlineFiltersData.carlineGroups

export default carlineFilterGroupsSelector
